import { ReactComponent as ShareIcon } from "components/icons/share.svg";
import { ReactComponent as SoundOffIcon } from "components/icons/soundOffIcon.svg";
import { ReactComponent as SoundOnIcon } from "components/icons/soundOnIcon.svg";
import { ReactComponent as FullScreenIcon } from "components/icons/fullScreenIcon.svg";
import { ReactComponent as ExitFullScreenIcon } from "components/icons/exitFullScreen.svg";
import { ReactComponent as SDIcon } from "components/icons/sd.svg";
import { ReactComponent as HDIcon } from "components/icons/hd.svg";

import { Actions } from "./types";

export const VideoButtons = (props: {
  hasSound: boolean;
  fullScreen: boolean;
  hd: boolean;
  muted: boolean;
  haveFullScreen: boolean;
  onClick: (value: Actions) => void;
}): JSX.Element => {
  const onClick = (id: Actions) => () => {
    props.onClick(id);
  };

  return (
    <div className="buttons">
      {props.hasSound && props.muted && (
        <div className="button">
          <SoundOffIcon
            className="soundOff"
            onClick={onClick(Actions.UnMute)}
          />
          <span>Off</span>
        </div>
      )}

      {props.hasSound && !props.muted && (
        <div className="button">
          <SoundOnIcon
            className="soundOn"
            onClick={onClick(Actions.Mute)}
          />
          <span>On</span>
        </div>
      )}
      {props.haveFullScreen && (
        <div className="button">
          {props.fullScreen && (
            <ExitFullScreenIcon
              className="exitFullScreen"
              onClick={onClick(Actions.FullScreen)}
            />
          )}

          {!props.fullScreen && (
            <FullScreenIcon
              className="fullScreen"
              onClick={onClick(Actions.FullScreen)}
            />
          )}
        </div>
      )}

      {props.hd && (
        <div onClick={onClick(Actions.SD)} className="button">
          <HDIcon className="gifQuality" />
        </div>
      )}

      {!props.hd && (
        <div onClick={onClick(Actions.HD)} className="button">
          <SDIcon className="gifQuality" />
        </div>
      )}

      <div className="button" id="shareButton">
        <ShareIcon
          onClick={onClick(Actions.Share)}
        />
      </div>
    </div>
  );
};
